import { render } from "./FpuiTitleEditor.vue?vue&type=template&id=05377cc6&lang=pug"
import script from "./FpuiTitleEditor.vue?vue&type=script&lang=js"
export * from "./FpuiTitleEditor.vue?vue&type=script&lang=js"

import "./FpuiTitleEditor.vue?vue&type=style&index=0&id=05377cc6&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__